var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.detail)?_c('div',{attrs:{"id":"ft_main_myh01"}},[_c('div',{staticClass:"ft_wr"})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }